import { HttpErrorResponse } from '@angular/common/http';
import { notifyMessage } from '../../../constants/notify-message';
import { BuyerConfig } from '../../../interfaces/buyer-config.interface';

export class SurveyUpdateError extends Error {
  constructor(
    private readonly error: unknown,
    private readonly config: BuyerConfig,
    private readonly example: string | undefined = undefined
  ) {
    super('Survey Update Error');
    this.message = this._message();
  }

  private _message(): string {
    if (this.error instanceof HttpErrorResponse) {
      if (
        this.error.error.ps_api_response_message.includes('PO') &&
        !!this.example
      ) {
        return this._billing();
      }

      return this.error.error.ps_api_response_message;
    }

    return notifyMessage.errorMessage.API_ERROR;
  }

  private _billing(): string {
    if (this.config.enableBillingNumberRules) {
      return notifyMessage.errorMessage.SURVEY_LAUNCH.INVALID_BILLING_NUMBER_RULE.replace(
        ':BILLING_NUMBER_EXAMPLE',
        this.example!
      );
    }

    return notifyMessage.errorMessage.SURVEY_LAUNCH.INVALID_BILLING_NUMBER;
  }
}
